const UserStatsRecord = require('client-v2/common/models/user-stats/record')

module.exports = UserStatsRecord
